import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ACTIVE_DISCOUNT_CODES_WILL_BE_LOST:
        "Hvis du avbestiller, mister du aktive rabatter",
      CODES: "Koder:",
      CODE: "Kode:",
      END_SUBSCRIPTION_ANYWAY: "Avslutt abonnementet allikevel",
      CANCEL: "Avbryt",
      TAKE_A_LONGER_BREAK: "Jeg vil ta en lenger pause",
    },
    se: {
      ACTIVE_DISCOUNT_CODES_WILL_BE_LOST:
        "Dina aktiva rabatter kommer gå förlorade om du avslutar",
      CODES: "Rabattkoder:",
      CODE: "Rabattkod:",
      END_SUBSCRIPTION_ANYWAY: "Avsluta prenumeration ändå",
      CANCEL: "Avbryt",
      TAKE_A_LONGER_BREAK: "Pausa kontot istället",
    },
    dk: {
      ACTIVE_DISCOUNT_CODES_WILL_BE_LOST:
        "Dine aktive rabatter vil gå tabt, hvis du afmelder dit abonnement",
      CODES: "Rabatkoder:",
      CODE: "Rabatkode:",
      END_SUBSCRIPTION_ANYWAY: "Afmeld abonnement alligevel",
      CANCEL: "Afbryd",
      TAKE_A_LONGER_BREAK: "Hold pause i en begrænset periode",
    },
  } as const
)[language];
